import styled from 'styled-components'

export const Section = styled.section`
    margin-bottom: 40px;
`
export const SectionWithoutMarin = styled.section `
    margin-bottom: 0px;
`

